
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Share, Users, DollarSign, MessageSquare } from 'lucide-react';

interface QuickActionsProps {
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ 
  activeTab,
  setActiveTab
}) => {
  const actions = [
    {
      label: 'Send Referral',
      icon: <Share className="h-5 w-5" />,
      href: '#referrals-tab',
      variant: 'default' as const,
      color: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700',
      onClick: () => {
        if (setActiveTab) {
          setActiveTab('send');
        }
        const tabsElement = document.getElementById('referrals-tab');
        if (tabsElement) {
          tabsElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    {
      label: 'Track Referrals',
      icon: <Users className="h-5 w-5" />,
      href: '/user/referral-tracking',
      color: 'bg-gradient-to-r from-purple-500 to-purple-600 text-white hover:from-purple-600 hover:to-purple-700'
    },
    {
      label: 'Payouts',
      icon: <DollarSign className="h-5 w-5" />,
      href: '/user/payout-report',
      color: 'bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700'
    },
    {
      label: 'Support',
      icon: <MessageSquare className="h-5 w-5" />,
      href: '/user/support',
      color: 'bg-gradient-to-r from-amber-500 to-amber-600 text-white hover:from-amber-600 hover:to-amber-700'
    }
  ];
  
  return (
    <div className="bg-white rounded-xl shadow-sm p-6 mb-8">
      <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {actions.map((action, index) => (
          <Button
            key={index}
            className={`flex flex-col items-center justify-center h-24 p-4 rounded-xl transition-transform hover:-translate-y-1 ${action.color}`}
            onClick={action.onClick}
            asChild={!action.onClick}
          >
            {action.onClick ? (
              <div className="space-y-2">
                {action.icon}
                <span className="text-sm font-medium block">{action.label}</span>
              </div>
            ) : (
              <Link to={action.href} className="space-y-2">
                {action.icon}
                <span className="text-sm font-medium block">{action.label}</span>
              </Link>
            )}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
